module.exports = __webpack_public_path__ + "media/assets/img/slider/06-788aa261f5ea565091bd1057600098b6.jpg";